import React from 'react'
import {Menu, MenuDivider, MenuItem} from '@blueprintjs/core'

/**
 * Non-nested generic menu element
 * @param items: Array of MenuItem data
 * @param menuStyles
 * @param menuItemStyles
 * @param menuDividerStyles
 * @param className
 * @param menuItemLabelCallback
 * @param menuItemHrefCallback
 * @param alwaysShowNumItems: Boolean whether to always display number of results
 * @param large
 * @param props
 * @returns Menu JSX.Element
 */
export const CoreMenu = ({
                             items = [],
                             menuStyles = {},
                             menuItemStyles = {},
                             menuDividerStyles = {},
                             className,
                             menuItemLabelCallback,
                             menuItemHrefCallback,
                             alwaysShowNumItems = false,
                             large = false,
                             ...props
                         }) => {
    return (
        <Menu
            className={className}
            style={menuStyles}
        >
            {(items.length === 0 || alwaysShowNumItems) &&
                <MenuDivider
                    title={`${items.length} results found`}
                    style={menuDividerStyles}
                />}
            {items.map((item, index) => {
                return (
                    <MenuItem
                        key={`core-menu-item-${index}`}
                        label={
                            typeof menuItemLabelCallback === "function"
                                ? menuItemLabelCallback(items[index])
                                : undefined
                        }
                        href={
                            typeof menuItemHrefCallback === "function"
                                ? menuItemHrefCallback(items[index])
                                : undefined
                        }
                        style={menuItemStyles}
                        {...props}
                    />
                )
            })}
        </Menu>
    )
}